module.exports = __webpack_public_path__ + "static/media/male_fairy.24961eba.png";